export default {"src":"/_next/static/media/notifications.85a6f333.gif","height":540,"width":800};